import React from "react";
import { ColumnsLayout } from "@components";
import { Privacy } from "./Privacy";

export const PrivacyPage = () => {
  return (
    <ColumnsLayout>
      <Privacy />
    </ColumnsLayout>
  );
};
